<button [class]="[color, expand, size, onlyIcon, iconPosition]" [disabled]="disabled">
  <ng-content></ng-content>
</button>
